import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { InvoiceBasicTestComponent } from './components/invoice-basic-test/invoice-basic-test.component';
import { ContactBasicTestComponent } from './components/contact-basic-test/contact-basic-test.component';
import { NotificationReportComponent } from './components/notification-report/notification-report.component';
import { InvoiceSearchComponent } from './components/invoice-search/invoice-search.component';
import { ContactSearchComponent } from './components/contact-search/contact-search.component';
import { LoginComponent } from './components/login/login.component';
import { AuthGuardService } from './services/auth/auth-guard.service';
import { UserSearchComponent } from './components/user-search/user-search.component';
import { UserEditComponent } from './components/user-edit/user-edit.component';
import { RoleSearchComponent } from './components/role-search/role-search.component';
import { RoleEditComponent } from './components/role-edit/role-edit.component';
import { RouteListingComponent } from './components/route-listing/route-listing.component';
import { NavigationNodeEditComponent } from './components/navigation-node-edit/navigation-node-edit.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { FunctionSearchComponent } from './components/function-search/function-search.component';
import { FunctionEditComponent } from './components/function-edit/function-edit.component';
import { MonthlyBillingReportComponent } from './components/monthly-billing-report/monthly-billing-report.component';
import { LandingComponent } from './pages/landing/landing.component';
import { NavigateComponent } from './pages/navigate/navigate.component';
import { EtlIngestionResultComponent } from './pages/etl-ingestion-result/etl-ingestion-result.component';
import { TagsComponent } from './pages/tags/tags.component';
import { FileMappingsComponent } from './pages/file-mappings/file-mappings.component';
import { FileMappingComponent } from './pages/file-mapping/file-mapping.component';
import { NotificationSettingsComponent } from './pages/notification-settings/notification-settings.component';
import { NotificationContactsComponent } from './pages/notification-contacts/notification-contacts.component';
import { FileIngestionConfigComponent } from './pages/file-ingestion-config/file-ingestion-config.component';
import { CommsPlatformConfigComponent } from './pages/comms-platform-config/comms-platform-config.component';
import { CommsBlockoutSettingsComponent } from './pages/comms-blockout-settings/comms-blockout-settings.component';
import { PaymentsReportComponent } from './components/payments-report/payments-report.component';
import { CampaignTrackersComponent } from './pages/campaign-trackers/campaign-trackers.component';
import { NotificationSchedulesComponent } from './pages/notification-schedules/notification-schedules.component';
import { MonthlyBillingConfigComponent } from './pages/monthly-billing-config/monthly-billing-config.component';
import { ModelBuilderComponent } from './components/model-builder/model-builder.component';
import { CommsPlatformOnboardingComponent } from './components/comms-platform-onboarding/comms-platform-onboarding.component';
import { AutomationFreezeComponent } from './pages/automation-freeze/automation-freeze.component';
import { GatewayRequestsReportComponent } from './components/gateway-requests-report/gateway-requests-report.component';
import { QfundPostsReportComponent } from './components/qfund-posts-report/qfund-posts-report.component';
import { LandingDashboardComponent } from './pages/dashboard/sub-components/landing-dashboard/landing-dashboard.component';
import { TrendAnalysisLandingComponent } from './pages/trend-analysis/sub-components/trend-analysis-landing/trend-analysis-landing.component';
import { SettlementConfigComponent } from './pages/settlement-config/settlement-config.component';
import { AddEditCreditorComponent } from './pages/add-edit-creditors/add-edit-creditor.component';
import { VmDropConfigComponent } from './pages/vmdrop-config/vmdrop-config.component';
import { ReportsMenuComponent } from './pages/reports-menu/reports-menu.component';
import { OffersConfigComponent } from './pages/offers-config/offers-config.component';
import { ParentDashboardComponent } from './components/parent-dashboard/parent-dashboard.component';
import { SmsEmailErrorsLandingComponent } from './pages/reports/communication-reports/sms-email-errors/sms-email-errors-landing/sms-email-errors-landing.component';
import { PaymentPlanForecastComponent } from './pages/reports/financial-reports/payment-plan-forecast/payment-plan-forecast.component';
import { QfundDiscrepancyReportComponent } from './pages/qfund-discrepancy-report/qfund-discrepancy-report.component';
import { PaymentsByChannelComponent } from './pages/reports/audit-reports/payments-by-channel/payments-by-channel.component';
import { WebhookEventsComponent } from './pages/reports/audit-reports/webhook-events/webhook-events.component';
import { CrudWebhookSettingsComponent } from './pages/crud-webhook-settings/crud-webhook-settings.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },
    {
        path: 'dashboard',
        component: LandingDashboardComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'trend-analysis',
        component: TrendAnalysisLandingComponent,
        canActivate: [AuthGuardService],
    },
    { path: 'navigate', component: NavigateComponent },
    { path: 'login', component: LoginComponent },
    { path: 'landing', component: LandingComponent },
    {
        path: 'routelisting/:navigationNodeId',
        component: RouteListingComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'navigationnode/:navigationNodeId',
        component: NavigationNodeEditComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'navigationnode/:navigationNodeId/:parentNavigationNodeId',
        component: NavigationNodeEditComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'userprofile',
        component: UserProfileComponent,
        canActivate: [AuthGuardService],
    }, //
    {
        path: 'usersearch',
        component: UserSearchComponent,
        canActivate: [AuthGuardService],
    }, //
    {
        path: 'user/:userId',
        component: UserEditComponent,
        canActivate: [AuthGuardService],
    }, //
    {
        path: 'rolesearch',
        component: RoleSearchComponent,
        canActivate: [AuthGuardService],
    }, //
    {
        path: 'role/:roleId',
        component: RoleEditComponent,
        canActivate: [AuthGuardService],
    }, //
    {
        path: 'invoicesearch',
        component: InvoiceSearchComponent,
        canActivate: [AuthGuardService],
    }, //
    {
        path: 'contactsearch',
        component: ContactSearchComponent,
        canActivate: [AuthGuardService],
    }, //
    {
        path: 'invoicejson/:creditorId/:integrationLinkId',
        component: InvoiceBasicTestComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'contactjson/:creditorId/:integrationLinkId',
        component: ContactBasicTestComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'reports-menu',
        component: ReportsMenuComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'report/notifications',
        component: NotificationReportComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'report/gateway-requests',
        component: GatewayRequestsReportComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'report/qfund-transactions',
        component: QfundPostsReportComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'report/qfund-discrepancies',
        component: QfundDiscrepancyReportComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'report/payment-plan-forecast',
        component: PaymentPlanForecastComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'functionsearch',
        component: FunctionSearchComponent,
        canActivate: [AuthGuardService],
    }, //
    {
        path: 'function/:functionId',
        component: FunctionEditComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'report/monthlybilling',
        component: MonthlyBillingReportComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'etl-ingestion',
        component: EtlIngestionResultComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'notification-contacts',
        component: NotificationContactsComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'add-edit-creditor',
        component: AddEditCreditorComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'report/payments-by-channel',
        component: PaymentsByChannelComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'creditor-webhook-settings',
        component: CrudWebhookSettingsComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'campaign-trackers',
        component: CampaignTrackersComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'notification-schedules',
        component: NotificationSchedulesComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'file-ingestion-config',
        component: FileIngestionConfigComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'settlement',
        component: SettlementConfigComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'settlement-offer',
        component: OffersConfigComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'comms-blockout-settings',
        component: CommsBlockoutSettingsComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'vmdrop-config',
        component: VmDropConfigComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'menu-dashboard',
        component: ParentDashboardComponent,
    },
    { path: 'tags', component: TagsComponent, canActivate: [AuthGuardService] },
    {
        path: 'etl-ingestion',
        component: EtlIngestionResultComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'vmdrop-config',
        component: VmDropConfigComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'notification-settings',
        component: NotificationSettingsComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'comms-platform-config',
        component: CommsPlatformConfigComponent,
        canActivate: [AuthGuardService],
    },
    { path: 'filemappings', component: FileMappingsComponent }, //, canActivate: [AuthGuardService] },
    { path: 'filemapping/:filemappingid', component: FileMappingComponent }, //, canActivate: [AuthGuardService] }
    {
        path: 'report/payments',
        component: PaymentsReportComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'report/webhook-events',
        component: WebhookEventsComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'monthly-billing-config',
        component: MonthlyBillingConfigComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'dev/models/builder',
        component: ModelBuilderComponent,
    },
    {
        path: 'comms-platform-onboarding',
        component: CommsPlatformOnboardingComponent,
    },
    {
        path: 'automations-freeze',
        component: AutomationFreezeComponent,
    },
    {
        path: 'reports/sms-email-errors',
        component: SmsEmailErrorsLandingComponent,
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
